module.exports = __webpack_public_path__ + "static/media/noImageLV.b8b02457.jpg";